import type { ApiUserSavedSearch, SearchParams, UserSavedSearch } from "@/modules/jobAds/client/api/types"

import { SEARCH_ENGINE_VERSIONS } from "@/modules/jobAds/client/constants"
import { computeLocationObjectFromSingleQueryParam } from "@/modules/locations/locations"

export function computeUserSavedSearch(savedSearch: ApiUserSavedSearch): UserSavedSearch | null {
  const searchParams = JSON.parse(savedSearch.attributes) as SearchParams

  const searchEngineVersion = searchParams?.searchEngineVersion
  const hasEsSavedSearchInAlgolia =
    !searchEngineVersion || searchEngineVersion === SEARCH_ENGINE_VERSIONS.ELASTIC_SEARCH

  if (hasEsSavedSearchInAlgolia) {
    return null
  }

  const locationObj =
    searchParams?.locations.length >= 1 ? computeLocationObjectFromSingleQueryParam(searchParams.locations[0]) : {}

  const { radius, ...searchParamsWithoutRadius } = searchParams

  return {
    id: savedSearch.id,
    lastSearchTime: savedSearch.lastSearchTime,
    searchParams: locationObj.city
      ? searchParams
      : {
          ...searchParamsWithoutRadius,
          radius: "",
        },
    type: savedSearch.type as UserSavedSearch["type"],
  }
}
